import apiClient from './api';

export type AnalyticsRange = '24h' | '7d' | '30d' | '90d' | '12m';

/** One row of a ranked list (top pages, referrers, countries…) or a chart bucket. */
export interface Metric {
    x: string;
    y: number;
}

export interface StatsSummary {
    pageviews: number;
    visitors: number;
    visits: number;
    bounces: number;
    /** Seconds, summed over visits. */
    totaltime: number;
}

export interface AnalyticsDashboard {
    /** False while the server has no Umami configured (UMAMI_URL). */
    enabled: boolean;
    /** False until the app is published (nothing to measure yet). */
    published: boolean;
    range?: AnalyticsRange;
    unit?: 'hour' | 'day' | 'month';
    timezone?: string;
    startAt?: number;
    endAt?: number;
    summary?: StatsSummary;
    previous?: StatsSummary;
    series?: { pageviews: Metric[]; sessions: Metric[] };
    leads?: { whatsapp: number; phone: number; maps: number; email: number };
    pages?: Metric[];
    entries?: Metric[];
    referrers?: Metric[];
    countries?: Metric[];
    cities?: Metric[];
    devices?: Metric[];
    browsers?: Metric[];
    utmSources?: Metric[];
    utmCampaigns?: Metric[];
    /** 7 rows (Sunday first) x 24 hours of visitor counts. */
    weekly?: number[][];
    active?: number;
}

export const analyticsService = {
    async dashboard(applicationId: string, range: AnalyticsRange, tz: string): Promise<AnalyticsDashboard> {
        const res = await apiClient.get<{ data: AnalyticsDashboard }>(`/analytics/${applicationId}`, { params: { range, tz } });
        return res.data.data;
    },

    async active(applicationId: string): Promise<number> {
        const res = await apiClient.get<{ data: { visitors: number } }>(`/analytics/${applicationId}/active`);
        return res.data.data.visitors;
    },
};
